// extracted by mini-css-extract-plugin
export var videoReview__video = "style-module--video-review__video--1e909";
export var vidsTop = "style-module--vids-top--fb5db";
export var vidsTop__block = "style-module--vids-top__block--83bc8";
export var vidsTop__col = "style-module--vids-top__col--b69ae";
export var vidsTop__container = "style-module--vids-top__container--63b7b";
export var vidsTop__content = "style-module--vids-top__content--0141a";
export var vidsTop__informationWrapper = "style-module--vids-top__information-wrapper--687a5";
export var vidsTop__item = "style-module--vids-top__item--3f81c";
export var vidsTop__itemText = "style-module--vids-top__item-text--61dba";
export var vidsTop__name = "style-module--vids-top__name--2daf5";
export var vidsTop__quote = "style-module--vids-top__quote--ee67b";
export var vidsTop__row = "style-module--vids-top__row--355e8";
export var vidsTop__title = "style-module--vids-top__title--55230";
export var vidsTop__undertext = "style-module--vids-top__undertext--730ec";
export var vidsTop__uppertext = "style-module--vids-top__uppertext--af18a";
export var vidsTop__videoContainer = "style-module--vids-top__video-container--10ee8";